import { render, staticRenderFns } from "./ProductContainer.vue?vue&type=template&id=3e0d9aa9&"
import script from "./ProductContainer.vue?vue&type=script&lang=js&"
export * from "./ProductContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports